export default "__VITE_ASSET__Bv8Mb1Ng__"